import React, { useState, useContext } from "react";
import SidenavBar from "../shared/SideNavbar";
import Topbar from "../shared/Topbar";
import MainContent from "../shared/MainContent";
import { AuthContext } from "../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";

import "../style/pages/AdminHomePage.css";

const AdminHomePage = () => {
  const [isMenuActive, setMenuActive] = useState(false);
  const [selectedPage, setSelectedPage] = useState("");
  const { logoutUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const page = params.get("page");
    if (page) {
      setSelectedPage(page);
    } else if (!selectedPage) {
      setSelectedPage("dashboard");
    }
  }, [location.search, selectedPage]);

  const toggleMenu = () => {
    setMenuActive(!isMenuActive);
  };

  const handleMenuClick = (page) => {
    if (page === "logout") {
      logoutUser();
      navigate("/");
      return;
    }
    // Clear query parameters when manually selecting a page
    navigate(location.pathname, { replace: true });
    setSelectedPage(page);
  };

  const adminMenuItems = [
    { key: "home", title: "Scan QR", icon: "fa-solid fa-qrcode" },
    { key: "dashboard", title: "Dashboard", icon: "fa-solid fa-chart-line" },
    { key: "bulk_qr", title: "Bulk QR", icon: "fa-solid fa-print" },
    { key: "profile", title: "Profile", icon: "fa-solid fa-user-gear" },
    { key: "add_asset", title: "Add Asset", icon: "fa-solid fa-square-plus" },
    { key: "view_asset", title: "Assets", icon: "fa-solid fa-boxes-stacked" },
    { key: "add_location", title: "Add Container", icon: "fa-solid fa-map-location-dot" },
    { key: "view_location", title: "Containers", icon: "fa-solid fa-list-ul" },
    { key: "tags", title: "Tags", icon: "fa-solid fa-tags" },
    { key: "tree_view", title: "Tree View", icon: "fa-solid fa-sitemap" },
    { key: "settings", title: "Settings", icon: "fa-solid fa-gears" },
    { key: "api_tokens", title: "API Tokens", icon: "fa-solid fa-key" },
    { key: "smtp_config", title: "SMTP Config", icon: "fa-solid fa-envelope" },
    { key: "users", title: "User Management", icon: "fa-solid fa-users-gear" },
    { key: "logout", title: "Sign Out", icon: "fa-solid fa-sign-out-alt" },
  ];

  return (
    <div>
      <SidenavBar
        className={isMenuActive ? "active" : ""}
        toggleMenu={toggleMenu}
        handleMenuClick={handleMenuClick}
        menuItems={adminMenuItems}
        activeItem={selectedPage}
      />
      <div className={isMenuActive ? "main active" : "main"}>
        <Topbar toggleMenu={toggleMenu} className={isMenuActive ? "active" : ""} menuItems={adminMenuItems} handleMenuClick={handleMenuClick} />
        <MainContent selectedPage={selectedPage} className={isMenuActive ? "active" : ""} />
      </div>
    </div>
  );
};

export default AdminHomePage;
